import { useTranslation } from "react-i18next";
import { SceneTwitch as SceneTwitchType } from "@ltypes/scene";
import DisplayForm from "@components/forms/DisplayForm/DisplayForm";
import TextField from "@components/forms/TextField/TextField";
import StreamerList from "./StreamerList";
import { useSelector } from "react-redux";
import Product from "@ltypes/product";
import { displayModes } from "../../../constants";

type SceneTwitchProps = {
    scene: SceneTwitchType,
    onChange: (field: string, value: any) => void,
};

function SceneTwitch(props: SceneTwitchProps) {

    const { t } = useTranslation();
    const product: Product = useSelector((state: any) => state.product);

    return (
        <div className="row g-3">
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12">
                        <DisplayForm label={t('page.scenes.data.display_mode')} value={props.scene.display_mode} items={displayModes[product.model.type].twitch.map((index: number) => ({
                            id: index,
                            background: `twitch-${index}`,
                        }))} productModelType={product.model.type} onChange={(value: number) => props.onChange('display_mode', value)}/>
                    </div>
                    <div className="col-12">
                        <TextField label={t('page.scenes.data.display_duration')} value={props.scene.display_duration} onChange={(value: string) => props.onChange('display_duration', value)}/>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12">
                        <StreamerList label={t('page.scenes.data.streamer_names')} streamers={props.scene.streamers ?? []} onChange={(values) => props.onChange('streamers', values)}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SceneTwitch;
